import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=2add9250"
import script from "./CategoryView.ts?vue&type=script&lang=ts&external"
export * from "./CategoryView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports